<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <router-link
          to="/principal/client/add"
          class="btn btn-secondary"
        >Agregar Cliente</router-link>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :totalRows="totalRecords"
      :isLoading.sync="isLoading"
      styleClass="vgt-table bordered"
      :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'config'">
          <router-link
            :to="{ name: 'infoClient', params: { client: props.row}}"
            class="btn btn-secondary"
          >Configurar</router-link>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Clave',
          field: 'key_client',
          type: 'number',
          filterOptions: {
            placeholder: 'ID del almacén',
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Nombre',
          field: 'fullname',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true
          }
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Teléfono',
          field: 'phone',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Configurar Parametros',
          field: 'config'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      console.log('onColumnFilter', params)
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        console.log('this.serverParams', this.serverParams.columnFilters.key_client === undefined ? '' : this.serverParams.columnFilters.key_client)
        const items = {
          enterprise_id: this.user.enterprise_id,
          key_client: this.serverParams.columnFilters.key_client === undefined ? '' : this.serverParams.columnFilters.key_client,
          name: this.serverParams.columnFilters.fullname === undefined ? '' : this.serverParams.columnFilters.fullname,
          email: this.serverParams.columnFilters.email === undefined ? '' : this.serverParams.columnFilters.email,
          phone: this.serverParams.columnFilters.phone === undefined ? '' : this.serverParams.columnFilters.phone,
          perPage: this.serverParams.perPage
        }
        const response = await axiosAdelaService.post('/getClients', items)
        console.log('Clientes', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
